<template>
    <div class="selector">
      <!-- y axis min switch/input -->
      <b-form-input v-if="yMinEnabled" type="number" size="sm" placeholder="Y Min" v-model="yMinValue" @input="minChanged" />
      <div class="switcher">
        <!-- note: coreui v3 CSwitch issue, v-model doesn't work -->
        <CSwitch :checked.sync="yMinEnabled"
                  @update:checked="minChanged"
                  v-bind="switcherMinLabel"
                  class="mx-1" color="dark" variant="outline" shape="square" size="sm" />
      </div>
      <!-- y axis max switch/input -->
      <b-form-input v-if="yMaxEnabled" type="number" size="sm" placeholder="Y Max" v-model="yMaxValue" @input="maxChanged"/>
      <div class="switcher">
        <!-- note: coreui v3 CSwitch issue, v-model doesn't work -->
        <CSwitch :checked.sync="yMaxEnabled"
                  @update:checked="maxChanged"
                  v-bind="switcherMaxLabel"
                  class="mx-1" color="dark" variant="outline" shape="square" size="sm" />
      </div>
    </div>
</template>

<script>
  export default {
    name: 'graph-min-max-y-selector',
    components: {},
    props: {
      values: {
        type: Array,
        default: () => [],
      },
    },
    data: function () {
      return {
        yMaxEnabled: null,
        yMaxValue: null,
        yMinEnabled: null,
        yMinValue: null,

        switcherMaxLabel: {
          labelOn: 'max',
          labelOff: 'max'
        },
        switcherMinLabel: {
          labelOn: 'min',
          labelOff: 'min'
        },
      };
    },
    methods: {
      minChanged(value) {
        if(typeof value === 'boolean') {
          this.yMinValue = this.computedMinValue;
          this.$emit('min-changed', value ? this.yMinValue : null);
        } else {
          this.$emit('min-changed', parseInt(value));
        }
      },
      maxChanged(value) {
        if(typeof value === 'boolean') {
          this.yMaxValue = this.computedMaxValue;
          this.$emit('max-changed', value ? this.yMaxValue : null);
        } else {
          this.$emit('max-changed', parseInt(value));
        }
      },
    },
    computed: {
      computedMinValue: function () {
        return Math.min.apply(Math, this.values);
      },
      computedMaxValue: function () {
        return Math.max.apply(Math, this.values);
      },
    },
  }
</script>

<style scoped lang="scss">
  .selector {
    display: flex;
    justify-content: flex-end;
    padding: 5px 0;

    input.form-control {
      width: 60px;
      height: 21px;
      padding: 0.1rem 0.3rem;
    }
  }

  .switcher {
    display: flex;
    align-items: center;
    margin-left: 5px;
  }
</style>
